import api from '../token';

export const ListPerfil = async () => {
  try {
    const response = await api.post('/getPerfil');
    return response.data;
  } catch (error) {
  
    return [];
  }
};

